import React, {Component} from 'react';
import TimePicker from 'react-times';
import 'react-times/css/material/default.css';
import 'react-times/css/classic/default.css';
import '../assets/css/timepicker.css';

class TimeComp extends Component {
    
    render() {
        return (
            <TimePicker
                time={this.props.time}
                onTimeChange={this.props.onTimeChange.bind(this)}
            />
        )
    }
}

export default TimeComp;